module.exports = __webpack_public_path__ + "img/transcription.afbc27b0.svg";